var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.1499 18.8375H6.4499L15.1249 10.1625L13.8249 8.86252L5.1499 17.5375V18.8375ZM19.1249 8.82502L15.1499 4.87502L17.8124 2.21252L21.7624 6.18752L19.1249 8.82502ZM3.2749 20.7125V16.7375L13.8124 6.20002L17.7874 10.175L7.2499 20.7125H3.2749ZM14.4749 9.51252L13.8249 8.86252L15.1249 10.1625L14.4749 9.51252Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.fb3354d36e0c81b2ebbcd63f15019a1c.svg";
export { ForwardRef as ReactComponent };